import { FaLock } from "react-icons/fa";
import { Constant } from "../../config";
import { formatCountdown } from "../../hooks";

import {
  LockoutAction,
  LockoutCountdown,
  LockoutHint,
  LockoutIcon,
  LockoutNotice,
  LockoutText,
  LockoutTimer,
  LockoutTitle,
} from "./AuthStyles";

interface AccountLockedNoticeProps {
  /** Seconds left on the lockout; 0 means the wait is over. */
  remaining: number;
  /** Why the account was locked - differs between the login and OTP steps. */
  reason: string;
  /** Point the user at password reset while they wait (login screen only). */
  showResetHint?: boolean;
  /** Label for the way out of the lockout; omitted when there isn't one. */
  actionLabel?: string;
  /** Runs when the user takes that way out. */
  onAction?: () => void;
}

/**
 * Explains a temporary lockout and counts down to when sign-in reopens. The
 * countdown replaces the backend's "try again after 30 minutes" wording, which
 * goes stale the moment it is rendered.
 */
const AccountLockedNotice = (props: AccountLockedNoticeProps) => {
  const { remaining, reason, showResetHint, actionLabel, onAction } = props;
  const isOver = remaining <= 0;

  return (
    <LockoutNotice role="alert">
      <LockoutIcon aria-hidden="true">
        <FaLock />
      </LockoutIcon>
      <div>
        <LockoutTitle>{Constant.lockout.title}</LockoutTitle>
        <LockoutText>{isOver ? Constant.lockout.expired : reason}</LockoutText>

        {!isOver && (
          <>
            <LockoutCountdown>
              <span>{Constant.lockout.try_after}</span>
              <LockoutTimer aria-live="polite">
                {formatCountdown(remaining)}
              </LockoutTimer>
            </LockoutCountdown>

          </>
        )}

        {/* Only this account is locked, so offer the others a way through. */}
        {actionLabel && onAction && (
          <LockoutAction onClick={onAction}>{actionLabel}</LockoutAction>
        )}
      </div>
    </LockoutNotice>
  );
};

export default AccountLockedNotice;
